var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgEye = function SvgEye(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.69284,11.29876c-2.57667,-5.42785 -6.47156,-8.15945 -11.69285,-8.15945c-5.224,0 -9.11619,2.73159 -11.69285,8.16217a1.63896,1.63896 0 0 0 0,1.39977c2.57667,5.42785 6.47156,8.15945 11.69285,8.15945c5.224,0 9.11619,-2.73159 11.69285,-8.16217c0.20929,-0.44032 0.20929,-0.9513 0,-1.39977zm-11.69285,7.60498c-4.38414,0 -7.5941,-2.22332 -9.8582,-6.90373c2.2641,-4.68041 5.47406,-6.90373 9.8582,-6.90373c4.38414,0 7.5941,2.22332 9.8582,6.90373c-2.26138,4.68041 -5.47134,6.90373 -9.8582,6.90373zm-0.10872,-11.68742c-2.6419,0 -4.78369,2.14179 -4.78369,4.78369s2.14179,4.78369 4.78369,4.78369s4.78369,-2.14179 4.78369,-4.78369s-2.14179,-4.78369 -4.78369,-4.78369zm0,7.82785c-1.68245,0 -3.04417,-1.36172 -3.04417,-3.04417s1.36172,-3.04417 3.04417,-3.04417s3.04417,1.36172 3.04417,3.04417s-1.36172,3.04417 -3.04417,3.04417z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.8f64de3bdaad08c216b1df66468d4990.svg";